export default "__VITE_ASSET__BrGb4FVU__"